<div class="tam-contact-control" attr.tid="{{config.controlName}}">
    <input class="tam-input" #inputTextFiled [(ngModel)]="inputValue" [style.width.px]="childConfig.css.width"
        [style.height.px]="childConfig.css.height" (ngModelChange)="textChange($event)"
        [maxLength]='config.maxLength||63' (blur)="onBlur()" />
    <div>
        <label [hidden]="!hintContent" class="item-label-error">
            {{hintContent}}
        </label>
    </div>
</div>